<template lang="pug">
  v-card(flat tile)
    v-tabs(
      v-model='currentTab'
      show-arrows
      background-color='primary'
      color='var(--bg-main-color)'
      grow
      icons-and-text
      centered
    )
      v-tab(
        v-for='(itemCondition,i) in numberConditions'
        v-show='dataFilter(itemCondition).length!==0'
        :key='i'
        @click='setResultShow(itemCondition)'
      )
        h5 ({{ dataFilter(itemCondition).length }})
        h4 {{ itemCondition.number_type.name }}
    v-virtual-scroll.overycard.mb-10(
      v-if='tabStatus&&dataFilter(resultShow).length!==0'
      :bench='10'
      :height='getHeight'
      :items='dataFilter(resultShow)'
      item-height='45'
    )
      template(v-slot='{item}')
        v-list-item(:key='item.id')
          v-list-item-action
            v-card.d-flex.justify-center.py-2(
              width='60'
              flat
              dark
              color='#1365ff'
            ) {{ item.number }}
          v-list-item-content
            v-row(align="center")
              v-col
                n-number-field-specific.ml-1(
                  v-model.number='item.unit'
                  :placeholder="$t('placeholder.unit-number')"
                  hide-details='auto'
                  @keydown='autoCheck (item,resultShow,$event)'
                  @input='sumUserPrice'
                )
              v-col
                h6 {{ $t('reward-stake') }} : {{ item.unit ? (item.unit*item.userReward) : 0.00 | currency }}
          v-list-item-action
            v-btn(
              dark
              small
              depressed
              width='30'
              min-width='30'
              color='#db4437'
              @click='openDeleteRow(item)'
            )
              v-icon mdi-close

</template>
<script>  
import * as c from '@/const/setTimeOutConfig' 
export default {
  props : {
    numberConditions : {
      type : Array,
      default : ()=> []
    },
    userSelect : {
      type:Array,
      default : ()=>[]
    },
    sumUserPrice : {
      type : Function,
      default : ()=>''
    },
    openDeleteRow : {
      type : Function,
      default : ()=>''
    }
  }, 
  data : () => ({
    panel : 0,
    currentTab : 0,
    resultShow : {},
    userlength : 0,  
    tabStatus : true
  }),
  computed : {
    getHeight () {
      return isNaN(window.innerHeight)||window.innerHeight===undefined ? window.clientHeight : window.innerHeight;
    }
  },
  watch : { 
    currentTab () {
      this.tabStatus = false
      setTimeout(()=>{
        this.tabStatus = true
      },c.RESULTLISTGAMETABDELAY)
    },
    userSelect () {     
      if(this.userSelect.length!==0){  
        this.autoExpand()  
        this.userlength = this.userSelect.length
      } 
    }
  },
  created () {
    this.autoExpand() 
  },
  methods : {
    setResultShow (item) {
      this.resultShow = item
    },
    autoCheck (item,itemCondition,evt) {  
      var currentInput = item.unit+evt.key   
      if(parseInt(currentInput)>itemCondition.max_unit_per_number_per_list){ 
        item.unit=itemCondition.max_unit_per_number_per_list 
        evt.preventDefault()
        this.sumUserPrice()
        return
      } else if(item.unit[0]==='0'){
        item.unit=1
        evt.preventDefault()
        this.sumUserPrice()
        return
      }   
    },
    autoExpand () {  
      var item = this.userSelect[this.userSelect.length-1] 
      // this.panel = this.numberConditions.findIndex(x=>x.number_type.id===item.number_type_id) 
      if(item&&item.number_type_id){   
        if(this.userlength<this.userSelect.length||this.dataFilter(this.resultShow).length===0){    
          this.resultShow =  this.numberConditions.find(x=>x.number_type.id===item.number_type_id)
          this.currentTab = this.numberConditions.findIndex(x=>x.number_type.id===item.number_type_id)  
        } 
      }   
    },
    dataFilter (item){ 
      return item.number_type ?
        this.userSelect.filter(x=>x.number_type_id===item.number_type.id)
        : [] 
        // .sort((a,b) => a.number - b.number)
    },
  }
}
</script>  